import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly TOKEN_KEY = 'auth_token';

    constructor(private router: Router) { }

    /**
     * Sets the authentication token.
     * @param token The JWT token to store.
     */
    setToken(token: string): void {
        localStorage.setItem(this.TOKEN_KEY, token);
    }

    /**
     * Gets the authentication token.
     * @returns The JWT token or null if not found.
     */
    getToken(): string | null {
        return localStorage.getItem(this.TOKEN_KEY);
    }

    /**
     * Removes the authentication token.
     */
    removeToken(): void {
        localStorage.removeItem(this.TOKEN_KEY);
    }

    /**
     * Checks if the user is authenticated.
     * @returns True if a token exists, false otherwise.
     */
    isAuthenticated(): boolean {
        const token = this.getToken();
        // In a real app, you might want to check token expiration here
        return !!token;
    }

    /**
     * Logs out the user and redirects to login.
     */
    logout(): void {
        this.removeToken();
        this.router.navigate(['/login']);
    }
}
